import React from 'react';
import { connect } from 'react-redux';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectHasNonRegularStyleById } from '../_redux';
import { FontFamilyWindow } from './font-family/FontFamilyWindow';
import { FontStylingOptions } from './styling-options/FontStylingOptions';
import { TextInputControlField } from './TextInputControlField';

const _TextInputControlWindowBody = ({ variableIds, hasNonRegularStyle }: OwnProps & Props) => (
    <Grid direction='row' justify='end' align='center' gap='s' wrap>
        <Cell full>
            <TextInputControlField variableIds={variableIds} />
        </Cell>
        <Cell>
            <FontFamilyWindow variableIds={variableIds} />
        </Cell>
        {hasNonRegularStyle && (
            <Cell fit>
                <FontStylingOptions variableIds={variableIds} />
            </Cell>
        )}
    </Grid>
);

type OwnProps = {
    variableIds: string[];
};

type Props = {
    hasNonRegularStyle: boolean;
};

const mapStateToProps = (state: GiftPdpState, { variableIds }: OwnProps) => ({
    hasNonRegularStyle: selectHasNonRegularStyleById(state, variableIds[0]!)
});

export const TextInputControlWindowBody = connect(
    mapStateToProps
)(_TextInputControlWindowBody);